/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetPrtimesMediaListsMediaOutletsResponseAllOf,
    GetPrtimesMediaListsMediaOutletsResponseAllOfFromJSON,
    GetPrtimesMediaListsMediaOutletsResponseAllOfFromJSONTyped,
    GetPrtimesMediaListsMediaOutletsResponseAllOfToJSON,
} from './GetPrtimesMediaListsMediaOutletsResponseAllOf';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';
import {
    PrtimesMediaOutlet,
    PrtimesMediaOutletFromJSON,
    PrtimesMediaOutletFromJSONTyped,
    PrtimesMediaOutletToJSON,
} from './PrtimesMediaOutlet';

/**
 * response of POST /prtimes_media_lists/media_outlets
 * @export
 * @interface GetPrtimesMediaListsMediaOutletsResponse
 */
export interface GetPrtimesMediaListsMediaOutletsResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetPrtimesMediaListsMediaOutletsResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetPrtimesMediaListsMediaOutletsResponse
     */
    message: string;
    /**
     * メディアの総数
     * @type {number}
     * @memberof GetPrtimesMediaListsMediaOutletsResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<PrtimesMediaOutlet>}
     * @memberof GetPrtimesMediaListsMediaOutletsResponse
     */
    prtimesMediaOutlets: Array<PrtimesMediaOutlet>;
}

export function GetPrtimesMediaListsMediaOutletsResponseFromJSON(json: any): GetPrtimesMediaListsMediaOutletsResponse {
    return GetPrtimesMediaListsMediaOutletsResponseFromJSONTyped(json, false);
}

export function GetPrtimesMediaListsMediaOutletsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPrtimesMediaListsMediaOutletsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'totalCount': json['total_count'],
        'prtimesMediaOutlets': ((json['prtimes_media_outlets'] as Array<any>).map(PrtimesMediaOutletFromJSON)),
    };
}

export function GetPrtimesMediaListsMediaOutletsResponseToJSON(value?: GetPrtimesMediaListsMediaOutletsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'total_count': value.totalCount,
        'prtimes_media_outlets': ((value.prtimesMediaOutlets as Array<any>).map(PrtimesMediaOutletToJSON)),
    };
}

